module.exports = __webpack_public_path__ + "img/logo.cf88a7a5.png";